export enum ImportStatus {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    PROCESSING = 'PROCESSING'
}
